<template>
  <div class="ak-blur-page">
    <p class="font-roboto ak-blur-page-message ak-colorText-sandWhite">
      Sie haben keinen Zugriff auf diese Seite. Bitte kontaktieren Sie
      <a
        class="font-roboto ak-colorText-sandWhite"
        href="email:anaking.gesundheit@zhaw.ch"
      >
        anaking.gesundheit@zhaw.ch
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AKAccessDeniedMessage',
};
</script>

<style lang="scss" scoped>
.ak-blur-page {
  background-color: var(--v-primary-base);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 9;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;

  &-message {
    font-size: 32px;
    text-shadow: 0 0 6px #000;
    text-align: center;
    width: 80vw;

    @media (min-width: map-get($grid-breakpoints, md)) {
      width: 60vw;
    }
  }
}
</style>
